import { getSlider } from "simple-slider/src/simpleslider.js";
import "intersection-observer";

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

const getAdElements = (container) => {
  return container.querySelectorAll(".ad");
};

const getAdContainers = () => {
  return document.querySelectorAll(".ads");
};

const getId = (el) => {
  if (!el) {
    throw new Error("No element provided.");
  }

  let id = el.dataset.id;

  if (isNaN(id)) {
    throw new Error("Element has no data-id.");
  }

  return id;
};

const sendRequest = (action, id) => {
  let data = {
    id: id,
  };
  data[window.csrfToken.name] = window.csrfToken.value;

  return fetch("/actions/nilmodule/default/" + action, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).catch((err) => {
    console.log(err);
  });
};

let adRequestQueue = [];
const addView = (currentElement, slider) => {
  adRequestQueue.push({
    type: "add-view",
    id: getId(currentElement),
    time: new Date(),
  });
  // sendRequest("add-view", getId(currentElement)).then(response => {
  //     slider.resume();
  // });
};

async function sendRequestQueue() {
  const now = new Date();

  let types = {};
  for (let i = 0; i < adRequestQueue.length - 1; i++) {
    let tmp = adRequestQueue[i];

    if (!tmp.syncing) {
      tmp.syncing = true;

      types[tmp.type] = types[tmp.type] || { items: [] };
      types[tmp.type].items.push(tmp);
    }
  }
  for (const [key, data] of Object.entries(types)) {
    await sendRequest(key, data.items.map((x) => x.id).join(",")).then(() => {
      for (let i = 0; i < adRequestQueue.length - 1; i++) {
        let tmp = adRequestQueue[i];
        if (tmp.time < now && tmp.id == data.id) {
          adRequestQueue.splice(i, 1);
        }
      }
    });
  }
}

const adHandler = (container) => {
  let timeout;
  const timer = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      sendRequestQueue();
      timer();
    }, 1000);
  };
  timer();

  let initSlider = (window.initSlider = (el) => {
    const children = getAdElements(el);
    let isNext = true;
    const slider = getSlider({
      container: el,
      children: children,
      transitionTime: 1,
      delay: 10,
      onChangeEnd: (index) => {
        let current = children[index];
        //addView(current, slider);
      },
    });

    if (children.length > 0) {
      //addView(children[0], slider);
    }
    const left = document.querySelector('.left[data-id="' + el.dataset.id + '"]');
    left.onclick = function() {
      if (isNext) {
        slider.reverse();
        isNext = false;
      }
      slider.next();
      slider.pause();
    };
    const right = document.querySelector('.right[data-id="' + el.dataset.id + '"]');
    right.onclick = function() {
      if (!isNext) {
        slider.reverse();
        isNext = true;
      }
      slider.next();
      slider.pause();
    };
    let touchstartX;
    let touchendX;
    let touchstartY;
    let touchendY;
    el.addEventListener('touchstart', function (event) {
      touchstartX = event.changedTouches[0].screenX;
      touchstartY = event.changedTouches[0].screenY;
    }, false);
    
    el.addEventListener('touchend', function (event) {
      touchendX = event.changedTouches[0].screenX;
      touchendY = event.changedTouches[0].screenY;
      handleGesture();
    }, false);
    
    
    function handleGesture() {
      const diffX = touchstartX - touchendX;
      const diffY = touchstartY - touchendY;
      if (Math.abs(diffY) > Math.abs(diffX)) {
        return;
      }
      if (touchendX < touchstartX) {
        if (isNext) {
          slider.reverse();
          isNext = false;
        }
        slider.next();
        slider.pause();
      }
      
      if (touchendX > touchstartX) {
        if (!isNext) {
          slider.reverse();
          isNext = true;
        }
        slider.next();
        slider.pause();
      }
    }
  });


  // getAdContainers().forEach(el => {
  initSlider(container);
  // });
};
window.adHandler = adHandler;

// document.addEventListener("DOMContentLoaded", adHandler);
